import { trackClientEvent } from '../../../../../trackClientEvent';
import { timingPairStringify, } from '@faire/web/common/timings/TimingMarker';
export const eventKey = 'api_performance-add_to_cart_action-timing';
/**
 * Triggered when the user adds an item to cart or updates a cart item&#39;s quantity
 */
export function trackApiPerformanceAddToCartActionTiming(timingParameterToken, Status, Variant2) {
    var _a;
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            timingParameterToken: (_a = timingPairStringify(timingParameterToken)) !== null && _a !== void 0 ? _a : '',
            Status,
            Variant2,
        },
    });
}
